import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getMembers, invalidateMembersCache } from '../../firebase';
import { membersApi } from '../../services/membersApi';
import type { UserProfile } from '../../models/FirestoreModels';

export const useMembers = (options?: { enabled?: boolean; forceRefresh?: boolean }) => {
  return useQuery<UserProfile[]>({
    queryKey: ['members', options?.forceRefresh ? 'fresh' : 'default'],
    queryFn: () => getMembers(options?.forceRefresh ?? false),
    enabled: options?.enabled ?? true,
    staleTime: 15 * 60 * 1000, // 15 minutes
    gcTime: 30 * 60 * 1000,   // 30 minutes
  });
};

export const useInvalidateMembers = () => {
  const queryClient = useQueryClient();
  return () => {
    invalidateMembersCache();
    return queryClient.invalidateQueries({ queryKey: ['members'] });
  };
};

export const useDirectory = (options?: { enabled?: boolean }) => {
  return useQuery<any[]>({
    queryKey: ['directory'],
    queryFn: () => membersApi.getDirectory(),
    enabled: options?.enabled ?? true,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000,   // 30 minutes
  });
};


